import  React, {Component} from 'react'
import IconButton from '@material-ui/core/IconButton'

const styles = {
    container: {
        position: 'fixed',
        right: 0,
        zIndex:999,
        backgroundColor: 'rgba(26, 27, 30, 0.94)',
    },
    spButton: {
        width: 40,
        color: 'rgb(255,255,255)',
    }
}

export default class Tools extends Component{
    render() {
        const { reduceMySize, maximizeMySize, openPanel } = this.props
        return(
            <div style={styles.container}>
                {/*<IconButton style={styles.spButton} onClick={maximizeMySize}>+</IconButton>*/}
                {/*<IconButton style={styles.spButton} onClick={reduceMySize}>-</IconButton>*/}
                <IconButton style={styles.spButton} onClick={openPanel}>
                    <i
                    className="fa fa-cog fa-md">
                </i> </IconButton>
            </div>
        )
    }
}
